import { render, staticRenderFns } from "./TrainingEditTab.vue?vue&type=template&id=585d2f9f&"
import script from "./TrainingEditTab.vue?vue&type=script&lang=js&"
export * from "./TrainingEditTab.vue?vue&type=script&lang=js&"
import style0 from "./TrainingEditTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports